import { Component, OnInit, Pipe, PipeTransform, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AuthenticationComponent } from '../shared/common/index';

import { PageContentService, SessionStorageService, ParameterConfigService, NewsLetterService } from '../core/index.service';
import { MaintenanceconfigService } from '../admin/index.service';

import { AppComponent } from '../app.component';
import { UserRole, RegStatus } from '../core/enumtype';
import { AppState } from '../statemanagement/app.state';
import { Store } from '@ngrx/store';

@Component({
    selector: 'home-index',
    templateUrl: './default.component.html',
    host: {
        '(window:resize)': 'onResize($event)'
    }
})
export class IndexComponent implements OnInit {

    public homeForm: FormGroup;
    txtTypeID: string;
    txtIntro: string;
    scrWidth: number;
    public maintenanceMessage: string;
    currentPage: string;
    paramInfo: any=[];
    snBln: any;
    blnskiplogin: boolean=false;
    constructor(
        private route: ActivatedRoute, private router: Router,
        private _fb: FormBuilder,
        private paramConfigService: ParameterConfigService,
        private pageContentService: PageContentService,
        private storageService: SessionStorageService,
        public appComponent: AppComponent,
        private newsLetterService: NewsLetterService,
        private dialog: MatDialog,
        private maintenanceService: MaintenanceconfigService,
        private store: Store<AppState>
    ) {
    }

    ngOnInit() {
        this.blnskiplogin=false;
        this.scrWidth = window.screen.width;

        this.displayCitizenNewsLetter(this.storageService.getJurisNo());
        this.getDownTimeMessage();
    }

    ngDoCheck() {
     let AllowSN=localStorage.getItem("AllowSNForms");
        
        if( this.blnskiplogin == true || AllowSN=="SN"){
            localStorage.setItem("SNForms","SN");
       } 
      
       else{
        localStorage.setItem("SNForms",null);
       }
      }
    // To display the News letter icon in home screen
    displayCitizenNewsLetter(JurisNo: number) {
        let isExists: boolean = false;
        this.newsLetterService
            .GetIsMainCitizenNews(JurisNo)
            .then(res => {
                this.appComponent.showNewsLetterIcon = (res.length > 0) ? true : false;
            });
        return isExists;
    }

    cmdRedirect(strPage: string) {
        this.pageContentService.pageContentYN = true;

        let link = [strPage];
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;
                    this.dialog.closeAll();

                    let dialogRef = this.dialog.open(AuthenticationComponent, {
                        disableClose: true,
                        panelClass: 'alert-modal',
                        data: {
                            message: strPage === 'services/location' ? 'House_Check' : 'The service is accessible to authenticated users only.',
                            RouterLink: strPage
                        }
                    });
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });

    }

    getContent(content: string, isHeader: boolean): string {
        if (this.scrWidth > 767) {
            if (isHeader) {
                if (content.length > 20) {
                    return content;
                }
                else
                    return content;
            }
            else {
                if (content.length > 45) {
                    return content.substring(0, 45) + "<span class='service-item-read-more'>...</span>";
                }
                else {
                    return content;
                }
            }
        }

        else {
            return content;
        }
    }

    showAllText(idString: string) {
     
       
        let div = document.querySelector('#' + idString + ' .full-text');
        let para = document.querySelector('#' + idString + ' .full-text p');
        let btn = document.querySelector('#' + idString + ' .full-text-close');
        let fullText = para.innerHTML;

        if (this.scrWidth > 767) {
            if (fullText.length > 40) {
                div.classList.add("show");
                btn.classList.add("show");
            }
        }
    }

    closeFullText(idString: string) {
        let div = document.querySelector('#' + idString + ' .full-text');
        let btn = document.querySelector('#' + idString + ' .full-text-close');
        div.classList.remove("show");
        btn.classList.remove("show");
    }


    onResize(event) {
        this.scrWidth = event.target.innerWidth;
    }

    enableServiceLink(): boolean {
        return this.paramConfigService.enableLink();
    }

    //Downtime Messsage
    public getDownTimeMessage() {
        this.maintenanceService
            .getDowntimeMessae()
            .then(res => {
                this.maintenanceMessage = (res) ? res.Description : null;
            })
    }

    cmdRedirectJOB(strPage: string, filename: string, FormType: string, ScreenName: string) {
  
  
        if(FormType=="SN"){
            this.store.select("parameter").subscribe(paramObject => {
                if (paramObject) {
                    this.paramInfo = paramObject[0];
                    for(let x of this.paramInfo){
                        if(x.ParamID==5625 ){
                    
                            this.snBln=x.DefaultValue;
                            if(this.snBln == "1"){
                               this.blnskiplogin=true; 
                                localStorage.setItem("SNForms",FormType);
                            }
                            else{
                                localStorage.setItem("SNForms",null);
                                this.blnskiplogin=false
                            }
                           
                    }
                  
                }
                   
                }
            });
        }
        else{
            localStorage.setItem("SNForms",null);
        }
   
        var names = "services/pdfformsview";
        let CitizenUserID = this.storageService.getUserID();
        this.storageService.setPDFUrl(names + '/' + filename + '/' + FormType + '/' + ScreenName);
        this.storageService.SetRequestFormUrl('services/servicejobapp/' + filename + '/' + FormType + '/' + ScreenName);
        this.pageContentService.pageContentYN = true;

        if (this.currentPage == ("/" + strPage)) {
            this.pageContentService.pageContentYN = false;
        }

        let link = [strPage];
        let filename1 = [filename];
        this.router.navigate([link, filename])
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != ("/" + strPage)) {
                        this.dialog.closeAll();
                        if (CitizenUserID == null || this.isAdminUser() || this.isSuperAdminUser()) {
                            this.dialog.open(AuthenticationComponent, {
                                disableClose: true,
                                panelClass: "alert-modal",
                                data: { message: strPage === 'Forms/PDFForm' ? 'PDFForm' : 'The service is accessible to authenticated users only.' }
                            });
                        }
                    }
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });
    }

    public isAdminUser(): boolean {
        if (this.storageService.getUserRole() == UserRole.Admin || this.storageService.getUserRole() == UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) {
            return true;
        }
        else {
            return false;
        }
    }

    public isSuperAdminUser(): boolean {
        if (this.storageService.getUserRole() == UserRole.SuperAdmin)
            return true;
        else
            return false;
    }

    OpenReportsWindow(CSPReportID: string) {
        this.router.navigateByUrl('services/reportspdfview/' + CSPReportID);
    }
    cmdRedirectPermitWindow(screenName: string) {        
        this.pageContentService.pageContentYN = true;
        let screen = screenName.split(' ').join('_');
        let strPage = 'citpermit/permit/' + screen;
        if (this.currentPage == ("/" + strPage)) {
            this.pageContentService.pageContentYN = false;
        }

        let link = [strPage];
        console.log(link);
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != ("/" + strPage)) {
                        this.dialog.closeAll();

                        this.dialog.open(AuthenticationComponent, {
                            disableClose: true,
                            panelClass: "alert-modal",
                            data: {
                                message: strPage === 'services/location' ? 'House_Check' : 'The service is accessible to authenticated users only.',
                                RouterLink: strPage
                            }
                        });
                    }
                }
            })
            .catch(err => {
                this.pageContentService.pageContentYN = false;
            });
    }
    //public getRegStatus(): boolean {
    //    if (this.storageService.getRegStatus() == RegStatus.AuthorizedUser || this.storageService.getRegStatus() == RegStatus.RegisterUser) {
    //        return true;
    //    }
    //    else {
    //        return false;
    //    }
    //}
}



// WEBPACK FOOTER //
// D:/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/home/default.component.ts